:host {
  display: flex;
  align-items: center;
}
.container {
  display: flex;
}
gz-icon-button {
  display: flex;
}
